import { render } from "./honoreePagination.vue?vue&type=template&id=2435fe9c"
import script from "./honoreePagination.vue?vue&type=script&lang=js"
export * from "./honoreePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__